import { render, staticRenderFns } from "./ImgPreview.vue?vue&type=template&id=6974585f"
import script from "./ImgPreview.vue?vue&type=script&lang=js"
export * from "./ImgPreview.vue?vue&type=script&lang=js"
import style0 from "./ImgPreview.vue?vue&type=style&index=0&id=6974585f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports